import { render, staticRenderFns } from "./AudioTable.vue?vue&type=template&id=bb4b4b80&scoped=true&"
import script from "./audiotable.js?vue&type=script&lang=js&"
export * from "./audiotable.js?vue&type=script&lang=js&"
import style0 from "./AudioTable.vue?vue&type=style&index=0&id=bb4b4b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4b4b80",
  null
  
)

export default component.exports